import { isSameId } from "../../helpers";
export default function (store, { id, userId }) {
    const task = store.getTask(id);
    if (task?.assigned?.some(i => isSameId(i, userId))) {
        store.in.exec("update-task", {
            id,
            task: {
                ...task,
                assigned: task?.assigned?.filter(id => id != userId),
            },
        });
    }
}
//# sourceMappingURL=unassign.js.map